import React from "react"
import { initials, colorFor } from "../helpers/format"

const sizes = {
  sm: "w-6 h-6 text-[10px]",
  md: "w-7 h-7 text-[11px]",
  lg: "w-9 h-9 text-[13px]",
}

const Avatar = ({ name, size = "sm", ring = true }) => {
  if (!name) {
    return (
      <span
        className={`inline-grid place-items-center rounded-full bg-slate-200 text-slate-500 ${sizes[size]} ${ring ? "ring-2 ring-white" : ""}`}
        title={I18n.t("projects.avatar.unassigned")}
      >
        ?
      </span>
    )
  }
  return (
    <span
      className={`inline-grid place-items-center rounded-full text-white font-semibold ${colorFor(name)} ${sizes[size]} ${ring ? "ring-2 ring-white" : ""}`}
      title={name}
    >
      {initials(name)}
    </span>
  )
}

export default Avatar
